import { useMemo } from 'react';
import { IconRotateClockwise2, IconRotate2 } from '@tabler/icons-react';
import { TransitionPropertyOptions } from './TransitionPropertyOptions';
import { TransitionRotateDirection } from '@/App/remotion/MainPlayer/types/Animations/Transitions/Transitions.types';

export const TransitionRotation = ({
  selectedValue,
  onChange,
  disabled
}: {
  selectedValue: TransitionRotateDirection | null;
  onChange: (value: TransitionRotateDirection) => void;
  disabled: boolean;
}) => {
  const options = useMemo(() => {
    return [
      { Icon: <IconRotateClockwise2 size={20} />, value: TransitionRotateDirection.CLOCKWISE },
      { Icon: <IconRotate2 size={20} />, value: TransitionRotateDirection.ANTI_CLOCKWISE }
    ];
  }, []);
  return (
    <div className="flex flex-1 flex-col">
      <div className="mb-1 mt-2.5 select-none text-xs font-medium text-[#A5A9AD]">Direction</div>
      <TransitionPropertyOptions
        disabled={disabled}
        options={options}
        onClick={onChange as any}
        selectedValue={selectedValue}
      />
    </div>
  );
};
